<template lang="pug">
#result
  h1 {{ $t("result.title") }}
  #result-data
    game-result-list-card-component
    result-rank-icon-component
</template>

<script>

import { mapState } from 'vuex'

import GameResultListCardComponent from '@/components/GameResultListCard'
import ResultRankIconComponent from '@/components/ResultRankIcon'

export default {
  components: {
    GameResultListCardComponent,
    ResultRankIconComponent
  },
  computed: {
    ...mapState({
      resultState: state => state.Result
    }),
    result: function () {
      return this.resultState.result
    }
  },
  created: function () {
    if (!this.result.score) {
      this.$router.push({ path: '/' })
    }
  }
}

</script>

<style>
#result-data {
  display: inline-flex;
  width: 100%;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Result.vue